import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { externalRedirectionMap } from '@core/configurations/external-redirection.config';
import { Observable, of } from 'rxjs';

export const externalRedirectionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const path: string = route.routeConfig?.path ?? '';
  const targetUrl: string = externalRedirectionMap[path];

  if (targetUrl) {
    window.open(targetUrl, '_blank');
  }

  return of(false);
};
